export default __webpack_public_path__ + "f1238c2a38c5fc6c5920fc889b2c0c19.svg";